import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { NpsPreviewModal, NpsSubmittedModal, NpsSurveyModal } from '@appsource/components/modals';
export const NpsModal = ({ email, showPreviewModal, onDismissPreview, onDismissSurvey, onSubmitted, correlationId, context })=>{
    const [hidePreviewDialog, { toggle: toggleHidePreviewDialog }] = useBoolean(!showPreviewModal);
    const [hideSurveyDialog, { toggle: toggleHideSurveyDialog }] = useBoolean(showPreviewModal);
    const [hideSubmittedDialog, { toggle: toggleHideSubmittedDialog }] = useBoolean(true);
    const handleDismissPreview = ()=>{
        toggleHidePreviewDialog();
        onDismissPreview();
    };
    const handleSubmitPreview = ()=>{
        toggleHidePreviewDialog();
        toggleHideSurveyDialog();
    };
    const handleDismissSurvey = ()=>{
        toggleHideSurveyDialog();
        onDismissSurvey();
    };
    const handleSubmitSurvey = (answer)=>{
        toggleHideSurveyDialog();
        onSubmitted(answer);
        toggleHideSubmittedDialog();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NpsPreviewModal, {
                hidden: hidePreviewDialog,
                onDismiss: handleDismissPreview,
                onSubmit: handleSubmitPreview,
                context: context
            }),
            /*#__PURE__*/ _jsx(NpsSurveyModal, {
                hidden: hideSurveyDialog,
                email: email,
                onDismiss: handleDismissSurvey,
                onSubmit: handleSubmitSurvey,
                context: context
            }),
            /*#__PURE__*/ _jsx(NpsSubmittedModal, {
                hidden: hideSubmittedDialog,
                onDismiss: toggleHideSubmittedDialog,
                context: context,
                correlationId: correlationId
            })
        ]
    });
};
